import axios from '../axios/axios'

export default {
  state: {
    departments: []
  },
  mutations: {
    loadDepartments(state, departments) {
      state.departments = departments
    },
    addDepartment(state, {id, name}) {
      state.departments.push({ id, name })
    },
    updateDepartment(state, {id, name}) {
      const department = state.departments.find(department => department.id === id)

      department.name = name
    }
  },
  actions: {
    async fetchDepartments({commit}) {
      try {
        commit('setLoading', true)
        const response = await axios.get('/departments')
        commit('loadDepartments', response.data.departments)
        commit('setLoading', false)
      } catch (e) {
        commit('setNotification', {type: 'error', text: e.response.data.message})
        commit('setLoading', false)
      }
    },
    async saveDepartment({commit}, name) {
      try {
        commit('setLoading', true)
        const response = await axios.post('/departments', {name})
        commit('addDepartment', response.data.department)
        commit('setNotification', {type: 'success', text: response.data.message})
        commit('setLoading', false)
        return true
      } catch (e) {
        commit('setNotification', {type: 'error', text: e.response.data.message})
        commit('setLoading', false)
        return false
      }
    },
    async updateDepartment({commit}, {id, name}) {
      try {
        commit('setLoading', true)
        const response = await axios.put(`/departments/${id}`, {name})
        commit('updateDepartment', {id, name})
        commit('setNotification', {type: 'success', text: response.data.message})
        commit('setLoading', false)
      } catch (e) {
        commit('setNotification', {type: 'error', text: e.response.data.message})
        commit('setLoading', false)
      }
    }
  },
  getters: {
    departments(state) {
      return state.departments
    }
  }
}
